import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { SessionTimeoutService } from '../services/session-timeout.service';

const SKIP_ACTIVITY_URL_PARTS = [
  '/auth/admin-login',
  '/auth/login',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/refresh',
  '/auth/logout',
];

function shouldSkipActivity(url: string): boolean {
  return SKIP_ACTIVITY_URL_PARTS.some((part) => url.includes(part));
}

/**
 * Treats completed HTTP exchanges as user activity for session idle tracking.
 */
export const sessionActivityInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionTimeout = inject(SessionTimeoutService);
  return next(req).pipe(
    tap({
      next: () => {
        if (!shouldSkipActivity(req.url)) {
          sessionTimeout.recordHttpActivity();
        }
      },
      error: () => {
        if (!shouldSkipActivity(req.url)) {
          sessionTimeout.recordHttpActivity();
        }
      },
    }),
  );
};
